import { useEffect, useRef } from 'react';
import { streakService } from '../services/streakService';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';

const STREAK_THRESHOLD = 180; // 180 seconds (3 minutes) as per user request

export const useStreakCounter = (isActive: boolean) => {
    const { user } = useAuth();
    const { refreshProfile } = useData();
    const secondsRef = useRef(0);

    useEffect(() => {
        if (!isActive || !user) {
            return;
        }

        const SYNC_TIMER_KEY = `libritui_streak_timer_${user.id}`;
        // Resume from localStorage if available
        if (secondsRef.current === 0) {
            const saved = localStorage.getItem(SYNC_TIMER_KEY);
            if (saved) secondsRef.current = parseInt(saved, 10);
        }

        const interval = setInterval(async () => {
            secondsRef.current += 1;
            
            // Periodically save to localStorage (every 10s)
            if (secondsRef.current % 10 === 0) {
                localStorage.setItem(SYNC_TIMER_KEY, secondsRef.current.toString());
            }

            if (secondsRef.current >= STREAK_THRESHOLD) {
                // Goal reached!
                const result = await streakService.validateAndIncrementStreak(user.id, 'reading');
                if (result && result.newlyIncremented) {
                    window.dispatchEvent(new CustomEvent('libritui-streak-updated', { 
                        detail: result 
                    }));
                    refreshProfile();
                }
                // Reset Both
                secondsRef.current = 0; 
                localStorage.removeItem(SYNC_TIMER_KEY);
            }
        }, 1000);

        return () => {
            clearInterval(interval);
            // Save on cleanup
            if (user) localStorage.setItem(SYNC_TIMER_KEY, secondsRef.current.toString());
        };
    }, [isActive, user, refreshProfile]);

    return {};
};
